var _ellipse, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftTokensIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 48,
    viewBox: "0 0 63 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 63 42.5)",
    fill: "url(#paint0_angular_4441_24547)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 24,
    r: 18.5,
    fill: "#627EEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 10.125L47.5938 24L39.5 20.3804V10.125Z",
    fill: "#C0CBF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 10.125L31.4062 24L39.5 20.3804V10.125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 20.3828L31.4062 24.0019L39.5 28.6269V20.3828Z",
    fill: "#C0CBF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 28.6269L47.5938 24.0017L39.5 20.3828V28.6269Z",
    fill: "#8197EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 30.3594L47.5938 25.1562L39.5 37.875V30.3594Z",
    fill: "#C0CBF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 30.3594L31.4062 25.1562L39.5 37.875V30.3594Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 42.5C44.7173 42.5 53 34.2173 53 24C53 13.7827 44.7173 5.5 34.5 5.5C24.2827 5.5 16 13.7827 16 24C16 34.2173 24.2827 42.5 34.5 42.5Z",
    fill: "#8247E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3853 19.6544C39.9575 19.4 39.4025 19.4 38.94 19.6544L35.61 21.5853L33.3438 22.8456L30.0253 24.7766C29.5975 25.0309 29.0425 25.0309 28.58 24.7766L25.9206 23.2734C25.4928 23.0191 25.2038 22.5566 25.2038 22.0478V19.0763C25.2038 18.5675 25.4581 18.1166 25.9322 17.8622L28.5338 16.3938C28.9616 16.1394 29.5166 16.1394 29.9791 16.3938L32.5806 17.8622C33.0084 18.105 33.3091 18.5675 33.3091 19.0763V21.0072L35.5753 19.7006V17.7697C35.5753 17.2609 35.3209 16.81 34.8469 16.5556L30.0253 13.7806C29.5975 13.5262 29.0425 13.5262 28.58 13.7806L23.6775 16.5556C23.1919 16.81 22.9375 17.2725 22.9375 17.7697V23.3544C22.9375 23.8631 23.1919 24.3141 23.6659 24.5684L28.5684 27.3434C28.9962 27.5978 29.5512 27.5978 30.0138 27.3434L33.3438 25.4472L35.61 24.1406L38.94 22.2559C39.3678 22.0016 39.9228 22.0016 40.3853 22.2559L42.9869 23.7244C43.4147 23.9788 43.7153 24.4413 43.7153 24.9384V27.9216C43.7153 28.4303 43.4609 28.8812 42.9869 29.1356L40.3853 30.6503C39.9575 30.9047 39.4025 30.9047 38.94 30.6503L36.3384 29.1819C35.9106 28.9275 35.61 28.465 35.61 27.9678V26.0369L33.3438 27.3434V29.2744C33.3438 29.7831 33.5981 30.2341 34.0722 30.4884L38.9747 33.2634C39.4025 33.5178 39.9575 33.5178 40.42 33.2634L45.3225 30.4884C45.7503 30.2341 46.0509 29.7716 46.0509 29.2744V23.6897C46.0509 23.1809 45.7966 22.73 45.3225 22.4756L40.3853 19.6544Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44Z",
    fill: "#2775CA",
    stroke: "#121212",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7998 33.8C39.1998 28.4 39.1998 19.4 33.7998 14",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1999 14.1992C8.7999 19.5992 8.7999 28.5992 14.1999 33.9992",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3999 27.1996C19.3999 28.9996 20.7999 30.3996 22.5999 30.3996H25.9999C27.3999 30.3996 28.7999 29.1996 28.7999 27.5996C28.7999 25.7996 27.9999 25.1996 26.9999 24.7996L21.3999 22.7996C19.9999 22.5996 19.3999 21.9996 19.3999 20.3996C19.3999 18.7996 20.5999 17.5996 22.1999 17.5996H25.7999C27.5999 17.5996 28.9999 18.9996 28.9999 20.7996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.5996V32.3996",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_4441_24547",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5 18.5) rotate(90) scale(18.5 18.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C5EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftTokensIcon);
export default __webpack_public_path__ + "static/media/nft-tokens-icon.51532ec7eb729b58a8fdfcc09037b5f6.svg";
export { ForwardRef as ReactComponent };